<template>

    <Toast/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 10px;"></div>

                    <div v-if="this.company.logo != null" class="field">
                        <img :src="imageSrc" alt="Logo" class="form-logo" />
                    </div>

                    <h2>Appointment Confirmation for {{ this.companyName }}</h2>

                    <div style="height: 20px;"></div>

                    <h3>Appointment Date and Time</h3>

                    <div class="field">
                        <label for="name">TBC</label>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import UserService from "@/service/UserService";
import AvailabilityService from "@/service/AvailabilityService";
import moment from 'moment';
import ClientService from "@/service/ClientService";

export default {
    components: {
        IsoEvolveFooter
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[DigitalBooking][mounted] System is active.");
            console.log("[DigitalBooking][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[DigitalBooking][mounted] System is NOT active.");
            console.log("[DigitalBooking][mounted] Error = ", e);
            this.$router.push("digitalbooking");
            return;
        }

        this.appointmentReference = this.$route.query.appointment;

        console.log("[DigitalBooking][mounted] appointmentReference = ", this.appointmentReference);

        // try {
        //     const [availabilityData, companyData] = await Promise.all([
        //         AvailabilityService.getCompanyAvailability(this.companyReference),
        //         CompanyService.getCompany(this.companyReference)
        //     ]);
        //
        //     this.availability = availabilityData.data;
        //     this.company = companyData.data;
        //
        //     this.processImageSrc();
        //
        //     if (this.availability.length > 0) {
        //         this.companyName = this.availability[0].companyName;
        //     }
        //
        //     this.locations = Array.from(
        //         new Map(
        //             this.availability
        //                 .filter(a => a.locationId && a.locationName)
        //                 .map(a => [a.locationId, {
        //                     id: a.locationId,
        //                     name: a.locationName
        //                 }])
        //         ).values()
        //     );
        //
        //     if (this.locations.length === 1) {
        //         this.booking.location = this.availability[0].locationId;
        //     }
        //
        //     this.practitioners = Array.from(
        //         new Map(
        //             this.availability
        //                 .filter(a => a.practitionerId && a.practitionerName)
        //                 .map(a => [a.practitionerId, {
        //                     id: a.practitionerId,
        //                     name: a.practitionerName
        //                 }])
        //         ).values()
        //     );
        //
        //     if (this.practitioners.length === 1) {
        //         this.booking.practitioner = this.availability[0].practitionerId;
        //     }
        //
        //     this.billingPlans = Array.from(
        //         new Map(
        //             this.availability
        //                 .filter(a => a.billingPlanId && a.billingPlanName)
        //                 .map(a => [a.billingPlanId, {
        //                     id: a.billingPlanId,
        //                     name: a.billingPlanName
        //                 }])
        //         ).values()
        //     );
        //
        //     if (this.billingPlans.length === 1) {
        //         this.booking.billingPlan = this.availability[0].billingPlanId;
        //     }
        //
        //     console.log("[DigitalBooking][mounted] this.availability = ", this.availability);
        //     console.log("[DigitalBooking][mounted] this.locations = ", this.locations);
        //     console.log("[DigitalBooking][mounted] this.practitioners = ", this.practitioners);
        //     console.log("[DigitalBooking][mounted] this.billingPlans = ", this.billingPlans);
        //
        //     this.booking.type = 'N';
        //     this.booking.taxRegistered = 'N';
        //
        //     this.loading = false;
        //
        // } catch (e) {
        //     console.error("[DigitalBooking][mounted] Error fetching additional data = ", e);
        // }
    },
    data() {

        return {
            profile: {},
            company: {},
            submitted: false,
            companyReference: null,
            appointmentReference: null,
            companyName: null,
            imageSrc: '',
            errorMessage: '',
            booking: {
                location: null,
                practitioner: null,
                billingPlan: null,
                timeSlot: null
            },
            availableSlotOptions: [],
            loadingSlots: false,
            availability: [],
            locations: [],
            practitioner: [],
            billingPlans: [],
            activeTab: 1,
            optionTypes: [
                {name: 'True', code: 'True'},
                {name: 'False', code: 'False'}
            ],
            statusTypes: [
                {name: 'Active', code: 'A'},
                {name: 'Inactive', code: 'I'},
                {name: 'Pending', code: 'P'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            clientTypes: [
                {name: 'Natural Person', code: 'N'},
                {name: 'Juristic Person', code: 'J'},
            ],
            genderTypes: [
                {name: 'Male', code: 'M'},
                {name: 'Female', code: 'F'},
                {name: 'Other', code: 'O'}
            ],
            countries: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Canada', code: 'CA'},
                {name: 'India', code: 'IN'},
                {name: 'United States', code: 'US'},
                {name: 'Namibia', code: 'NA'},
                {name: 'Australia', code: 'AU'},
                {name: 'New Zealand', code: 'NZ'},
                {name: 'Brazil', code: 'BR'},
                {name: 'China', code: 'CN'},
                {name: 'Egypt', code: 'EG'},
                {name: 'France', code: 'FR'},
                {name: 'Germany', code: 'DE'},
                {name: 'Japan', code: 'JP'},
                {name: 'Spain', code: 'ES'},
                {name: 'Slovenia', code: 'SV'},
                {name: 'Taiwan', code: 'TW'},
                {name: 'Other', code: 'OT'}
            ],
            regionsSouthAfrica: [
                {name: 'Gauteng', code: 'Gauteng'},
                {name: 'Western Cape', code: 'Western Cape'},
                {name: 'Kwa-Zulu Natal', code: 'Kwa-Zulu Natal'},
                {name: 'North-West', code: 'North-West'},
                {name: 'Free State', code: 'Free State'},
                {name: 'Eastern Cape', code: 'Eastern Cape'},
                {name: 'Mpumalanga', code: 'Mpumalanga'},
                {name: 'Northern Cape', code: 'Northern Cape'},
                {name: 'Limpopo', code: 'Limpopo'}
            ],
        }
    },
    watch: {
        'booking.location'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.booking.practitioner = null;
                this.booking.billingPlan = null;
                this.booking.timeSlot = null;
                this.availableSlotOptions = [];
            }

            this.fetchBookingAvailability();
        },

        'booking.practitioner'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.booking.timeSlot = null;
                this.availableSlotOptions = [];
            }

            this.fetchBookingAvailability();
        },

        'booking.billingPlan'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.booking.timeSlot = null;
                this.availableSlotOptions = [];
            }

            this.fetchBookingAvailability();
        }
    },
    computed: {
        canCreateBooking() {
            if ((this.booking.location) && (this.booking.practitioner) && (this.booking.billingPlan)
                && (this.booking.timeSlot) && (this.booking.existingClient) && (this.booking.type)
                && (((this.booking.type === 'J') && (this.booking.name)) ||
                    ((this.booking.type === 'N') && (this.booking.firstName) && (this.booking.lastName)))
                && (this.booking.email) && (this.booking.mobile)) {
                return true;
            } else {
                return false;
            }
        },
        filteredPractitioners() {
            if (!this.booking.location) {
                return [];
            }

            return Array.from(
                new Map(
                    this.availability
                        .filter(a =>
                            a.locationId === this.booking.location &&
                            a.practitionerId &&
                            a.practitionerName
                        )
                        .map(a => [
                            a.practitionerId,
                            {
                                id: a.practitionerId,
                                name: a.practitionerName
                            }
                        ])
                ).values()
            );
        },
        filteredBillingPlans() {
            if (!this.booking.location || !this.booking.practitioner) {
                return [];
            }

            return Array.from(
                new Map(
                    this.availability
                        .filter(a =>
                            a.locationId === this.booking.location &&
                            a.practitionerId === this.booking.practitioner &&
                            a.billingPlanId &&
                            a.billingPlanName
                        )
                        .map(a => [
                            a.billingPlanId,
                            {
                                id: a.billingPlanId,
                                name: a.billingPlanName
                            }
                        ])
                ).values()
            );
        },
    },
    methods: {
        processImageSrc() {
            if (this.company.logo != null) {
                const match = this.company.logo.match(/<img\s+[^>]*src="([^"]+)"/);
                if (match && match[1]) {
                    this.imageSrc = match[1]; // Valid base64 data URL
                    this.errorMessage = ''; // Clear any previous error messages
                } else {
                    this.imageSrc = ''; // Default or empty value
                    this.errorMessage = 'Invalid image data'; // Set an appropriate error message
                }
            }
        },
        getDayOfWeek(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString(undefined, { weekday: 'short' });
            // use 'long' if you want: Monday instead of Mon
        },
        async fetchBookingAvailability() {

            this.booking.timeSlot = null;
            this.availableSlotOptions = [];

            if (!this.booking.location || !this.booking.billingPlan) {
                return;
            }

            this.loadingSlots = true;

            try {
                const response = await AvailabilityService.getBookingAvailability(
                    this.companyReference,
                    this.booking.location,
                    this.booking.practitioner,
                    this.booking.billingPlan
                );

                this.availableSlotOptions = response.data.map(slot => ({
                    label: `${this.getDayOfWeek(slot.date)} · ${slot.date} · ${slot.startTime} – ${slot.endTime}`,
                    value: slot
                }));

                console.log("[DigitalBooking][createBooking] this.availableSlotOptions = ", this.availableSlotOptions);

            } catch (e) {
                console.error('[DigitalBooking][fetchBookingAvailability] Failed to fetch availability', e);
            } finally {
                this.loadingSlots = false;
            }
        },
        async createBooking() {
            console.log("[DigitalBooking][createBooking] this.booking = ", this.booking);

            this.submitted = true;

            try {
                var bookingDto = {
                    locationId: this.booking.location,
                    practitionerId: this.booking.practitioner,
                    billingPlanId: this.booking.billingPlan,
                    existingClient: this.booking.existingClient,
                    type: this.booking.type,
                    name: this.booking.name,
                    firstName: this.booking.firstName,
                    lastName: this.booking.lastName,
                    preferredName: this.booking.preferredName,
                    email: this.booking.email,
                    mobile: this.booking.mobile,
                    idNumber: this.booking.idNumber,
                    address1: this.booking.address1,
                    address2: this.booking.address2,
                    addressCountry: this.booking.addressCountry,
                    addressPostalCode: this.booking.addressPostalCode,
                    addressRegion: this.booking.addressRegion,
                    addressState: this.booking.addressState,
                    commStatus: this.booking.commStatus,
                    taxRegistered: this.booking.taxRegistered,
                    taxNumber: this.booking.taxNumber,
                    dob: moment(this.booking.dob)
                        .format('YYYY-MM-DD'),
                    bookingDateAndTime: moment(this.booking.timeSlot.startTimestamp)
                        .format('YYYY-MM-DD HH:mm')
                };

                console.log('[DigitalBooking][createBooking] bookingDto = ', bookingDto);

                const response = await ClientService.createClientBooking(
                    this.companyReference, bookingDto);
                console.log('[DigitalBooking][createBooking] Response = ', response);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Created booking',
                    life: 3000
                });

            } catch (error) {
                console.error('[DigitalBooking][createBooking] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to create booking. Please try again.',
                    life: 3000
                });
            }

            this.booking = {};

            if (this.locations.length === 1) {
                this.booking.location = this.availability[0].locationId;
            }

            if (this.practitioners.length === 1) {
                this.booking.practitioner = this.availability[0].practitionerId;
            }

            if (this.billingPlans.length === 1) {
                this.booking.billingPlan = this.availability[0].billingPlanId;
            }

            this.booking.type = 'N';
            this.booking.taxRegistered = 'N';

            this.activeTab = 1;
            this.submitted = false;
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

img {
    max-width: 100%;
    height: auto;
}

.form-logo {
    width: clamp(120px, 40vw, 240px);
    height: auto;
    display: block;
    margin: 0 auto;
}
</style>
